import React, { useState } from "react";
import "../MarkSubmission/MarkSubmissionTable.css";
import { useLocation } from 'react-router-dom';
import {useConsortiaCenter} from "../../context/ConsortiaCenterContext";
import {getCenterType, checkunitIsConsortiaUnit} from "../../utils/utils";
import { useSubject } from "../../context/SubjectContext";
import { useCenter } from "../../context/CenterContext";

const UpdateMarkSubmissionTable = ({
  showError,
  rows,
  availableAssignments,
  setRows,
  candidates,
  anyRowInvalid,
  isRowComplete,
  isPostStage3,
}) => {

  const [sortKey, setSortKey] = useState("candidateName");
  const [sortDirection, setSortDirection] = useState("asc");
  const location = useLocation();
  const { unit } = location.state || {};
   const { centerNumber } = useCenter();
     const { sessionId } = location.state || {};
     const { subjectData } = useSubject();
   const { consortiaCentres = [] } = useConsortiaCenter();
    const currentCentreType = getCenterType(consortiaCentres, Number(centerNumber), subjectData?.selectedSubject, subjectData?.selectedSubjectId) || "";
    const unitcode = String(unit).split(" ")[0].trim().toUpperCase();
    
      const isConsortiaUnit = checkunitIsConsortiaUnit(
        consortiaCentres,
        centerNumber,
        sessionId,
        unitcode,
      );

  // Helper to get sorted index mapping
  const sortedIndexes = [...candidates.keys()].sort((a, b) => {
    let compareVal = 0;
    if (sortKey === "status") {
      // Incomplete (missing marks or assignment) should come first
      const aComplete = isRowComplete(rows[a]);
      const bComplete = isRowComplete(rows[b]);
      compareVal =
        aComplete === bComplete
          ? 0
          : aComplete
            ? 1 // complete (green tick) after
            : -1; // incomplete (red exclamation) before
    } else if (sortKey === "candidateName") {
      compareVal = candidates[a].candidateName.localeCompare(candidates[b].candidateName);
    } else if (sortKey === "candidateNumber") {
      compareVal = candidates[a].candidateNumber.localeCompare(candidates[b].candidateNumber);
    }
    return sortDirection === "asc" ? compareVal : -compareVal;
  });

  // Handler for clicking column headers
  const onSortColumn = (key) => {
    if (sortKey === key) {
      setSortDirection((dir) => (dir === "asc" ? "desc" : "asc"));
    } else {
      setSortKey(key);
      setSortDirection("asc");
    }
  };

  const handleInputChange = (idx, field, value, oldValue) => {
    const newRows = [...rows];
    if (field === "absent") {
      newRows[idx].markAsAbsent = value;
      if (value) {
        newRows[idx].totalCriteriaAchieved = "";
        newRows[idx].assignmentId = "";
        newRows[idx].assignment = "";
      }
    } else if (field === "marks") {
      const regex = /^\d{0,2}$/;
      if (value === "" || regex.test(value)) {
        newRows[idx].totalCriteriaAchieved = value;
      }
    } else if (field === 'copy') {
      const regex = /^\d{0,2}$/;
      if (!value || value === "" || regex.test(value)) {
        newRows[idx].totalCriteriaAchieved = oldValue;
      }
    } else if (field === "assignmentId") {
      // Store both assignmentId and assignment label for download
      newRows[idx].assignmentId = value;
      const selectedAssignment = availableAssignments.find(
        (a) => String(a.assignmentId) === String(value)
      );
      newRows[idx].assignment = selectedAssignment?.assignmentLabel || "";
    } else {
      newRows[idx][field] = value;
    }
    setRows(newRows);
  };

  return (
    <div>
      {showError && anyRowInvalid && (
        <div
          className="notification is-danger is-flex mt-4"
          id="pnlErrors"
          style={{
            alignItems: "flex-start",
            textAlign: "left",
          }}
        >
          <span className="icon mr-4">
            <svg
              focusable="false"
              aria-hidden="true"
              viewBox="0 0 24 24"
              style={{ width: 24, height: 24 }}
            >
              <path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z" />
            </svg>
          </span>
          <span>
            <strong>There are missing marks.</strong>
            <br />
            Please scroll down and make sure you have entered a valid mark for every candidate.
          </span>
        </div>
      )}
      <div className="table-container hide-icons">
        <table className="table is-hoverable mark-table">
          <colgroup>
            <col className="col-status" />
            <col className="col-number" />
            <col className="col-name" />
            <col className="col-absent" />
            <col className="col-marks" />
            <col className="updated-marks" />
            <col className="col-assignment" />
          </colgroup>
          <thead>
            <tr className="table-row-fullwidth">
              <th
                onClick={() => onSortColumn("status")}
                style={{ cursor: "pointer" }}
              >
                Status
                <span className="status-caret">
                  {sortKey === "status"
                    ? sortDirection === "asc"
                      ? " ⇅"
                      : " ⇅"
                    : " ⇅"}
                </span>
              </th>
              <th
                style={{
                  display:
                    currentCentreType === "Lead" && isConsortiaUnit
                      ? "table-cell"
                      : "none", // Show only if both conditions are met
                }}
              >
                {currentCentreType === "Lead" && isConsortiaUnit ? "Centre number" : ""}
              </th>
              <th>
                Candidate <br /> number
              </th>
              <th
                onClick={() => onSortColumn("candidateName")}
                style={{ cursor: "pointer" }}
              >
                Candidate name
                <span>
                  {sortKey === "candidateName"
                    ? sortDirection === "asc"
                      ? " ⇅"
                      : " ⇅"
                    : " ⇅"}
                </span>
              </th>
              <th>
                Absent?
              </th>
              {isPostStage3 ? 
              <th style={{width: '180px'}}>  <span>Last submitted</span>
                <br />
                <span>total mark</span><span className="icon" style={{ fill: '#0076BD', marginLeft: '4px', cursor: 'pointer',position: 'relative', top: '5px' }}>
<span  title="This shows the most recent centre mark submitted during the moderation process. It does not include any mark changes as a result of moderation.">
<svg  xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="212121"><path d="M440-280h80v-240h-80v240Zm40-320q17 0 28.5-11.5T520-640q0-17-11.5-28.5T480-680q-17 0-28.5 11.5T440-640q0 17 11.5 28.5T480-600Zm0 520q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Z"></path></svg>
</span>
</span>
                </th> :
              <th>
                <span>Original total</span>
                <br />
                <span>number of</span>
                <br />
                <span className="text-fields">criteria achieved</span>
              </th> }
                <th>
                Updated total number of
                <br />
                criteria achieved
              </th>
              <th>Assignment</th>
            </tr>
          </thead>
          <tbody>
            {sortedIndexes.map((idx) => {
              const candidate = candidates[idx];
              const row = rows[idx];
              const complete = isRowComplete(row);
              return (
                <tr className={`table-row-fullwidth ${row.disableCandidate ? 'disabled-row' : ''}`} key={candidate.candidateNumber}>
                  <td className="col-status">
                    <span className="candidate-status">
                      <span
                        className="icon"
                        title={
                          complete
                            ? "Marks complete for this candidate"
                            : "Marks need entering for this candidate"
                        }
                      >
                        {complete ? (
                          // GREEN TICK SVG
                          <svg
                            style={{ fill: "#2B8000" }}
                            focusable="false"
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3.88-11.71L10 14.17l-1.88-1.88a.9959.9959 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l2.59 2.59c.39.39 1.02.39 1.41 0L17.3 9.7c.39-.39.39-1.02 0-1.41-.39-.39-1.03-.39-1.42 0z"></path>
                          </svg>
                        ) : (
                          // RED EXCLAMATION SVG
                          <svg
                            style={{ fill: "#D9221C" }}
                            aria-hidden="true"
                            viewBox="0 0 24 24"
                          >
                            <path d="M12 7c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1s-1-.45-1-1V8c0-.55.45-1 1-1zm-.01-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-3h-2v-2h2v2z" />
                          </svg>
                        )}
                      </span>
                    </span>
                  </td>
                   {currentCentreType === "Lead" && isConsortiaUnit && (
                    <td className="col-number">{candidate.centreNumber}</td>
                  )}
                  <td className="col-number">{candidate.candidateNumber}</td>
                  <td className="col-name">
                    {candidate.candidateName.replace(":", ":")}
                  </td>
                  <td>
                    <label
                      className="checkbox label"
                      style={{ fontWeight: 400 }}
                    >
                      <input
                        type="checkbox"
                        checked={row.markAsAbsent}
                        onChange={(e) =>
                          handleInputChange(idx, "absent", e.target.checked)
                        }
                        disabled={true}
                      />
                      Absent
                    </label>
                  </td>
                  <td style={{paddingTop: '22px'}}>
                    {!row.markAsAbsent &&
                      <div
                        className="mark-input-wrapper"
                      >
                        <span className="max-mark-text bold-score">{row.existingTotalCriteriaScore}</span>
                        <span className="max-mark-text">/ {row.totalMarks}</span>
                      </div>}
                  </td>
                  <td style={{paddingTop: '22px'}}>
                    {!row.disableCandidate && (
                      <div className="mark-input-wrapper">
                        {/* Copy icon button */}
                        <button
                          className="button is-rounded copy-icon-btn"
                          id="btnCopyOriginalMark_7"
                          data-original-mark-button="true"
                          title="Copy original value"
                          onClick={() =>
                            handleInputChange(
                              idx,
                              "copy",
                              row.totalCriteriaAchieved,
                              row.existingTotalCriteriaScore
                            )
                          }
                        >
                          <span className="icon" title="Copy original value">
                            <svg
                              className="copy-icon-svg"
                              xmlns="http://www.w3.org/2000/svg"
                              height="24px"
                              viewBox="0 -960 960 960"
                              width="24px"
                              aria-hidden="true"
                              focusable="false"
                            >
                              <circle cx="480" cy="-480" r="440" fill="transparent" />
                              <path
                                d="M396-200q-97 0-166.5-63T160-420q0-94 69.5-157T396-640h252L544-744l56-56 200 200-200 200-56-56 104-104H396q-63 0-109.5 40T240-420q0 60 46.5 100T396-280h284v80H396Z"
                                fill="#767676"
                              />
                            </svg>
                          </span>
                        </button>

                        {/* Input field */}
                        <input
                          className="input input-total-mark update-total-mark"
                          type="text"
                          value={row.totalCriteriaAchieved}
                          onChange={(e) =>
                            handleInputChange(
                              idx,
                              "marks",
                              e.target.value.replace(/[^0-9]/g, "")
                            )
                          }
                          maxLength={2}
                          inputMode="numeric"
                          pattern="[0-9]*"
                        />
                        <span className="max-mark-text">
                          / {row.totalMarks}
                        </span>
                      </div>
                     )}

                  </td>
                  <td>
                    {!row.markAsAbsent && <div
                      className={'select input-assignment'}
                    >
                      <select
                        value={row.assignmentId}
                        onChange={(e) =>
                          handleInputChange(idx, "assignmentId", e.target.value)
                        }
                        disabled={true}
                      >
                        <option value="">-- Select assignment --</option>
                        {availableAssignments.map((assignment) => (
              <option
                  key={assignment.assignmentId}
                  value={assignment.assignmentId}
              >
                  {assignment.assignmentLabel}
              </option>
          ))}
                      </select>
                    </div>}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default UpdateMarkSubmissionTable;